// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"366":"23e47570","407":"23e47570","545":"33945c7c","575":"2d01211b","749":"2d01211b","844":"33945c7c"}[chunkId] + ".chunk.css";
};